module.exports = __webpack_public_path__ + "img/637025821341678213zelfbeeld.jpg";